import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";

const WidthWarningPop = () => {
  const [showWarningPop, setShowWarningPop] = useState(false);

  useEffect(() => {
    const checkWidth = () => {
      if (window.innerWidth < 740) {
        setShowWarningPop(true);
      } else {
        setShowWarningPop(false);
      }
    };

    checkWidth();

    // Listen to window resize
    window.addEventListener("resize", checkWidth);

    // Clean up
    return () => {
      window.removeEventListener("resize", checkWidth);
    };
  }, []);

  const defaultWarningPopupStyle = {
    color: "secondary.main",
    textAlign: "center",
    marginTop: "20px",
    fontWeight: "bold",
  };

  return (
    <Dialog open={showWarningPop} fullWidth>
      <DialogTitle>
        <Typography
          variant="h4"
          sx={{ ...defaultWarningPopupStyle, color: "red" }}
        >
          Unsupported Screen Size
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="h5" sx={defaultWarningPopupStyle}>
          Oooops!
        </Typography>
        <Typography sx={defaultWarningPopupStyle}>
          This app is best experienced on larger screens.
        </Typography>
        <Typography sx={defaultWarningPopupStyle}>
          This screen is a bit too small.
        </Typography>
        <Typography sx={defaultWarningPopupStyle}>
          Please switch to a device with a width of at least 740px.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default WidthWarningPop;
